import { create } from "zustand"
import { persist } from "zustand/middleware"
import type { ILoggedUser } from "@/entities/auth/types.ts"
import { Auth } from "@/shared/lib"

interface IAuthStore {
  isAuthorized: boolean
  me?: ILoggedUser
}

interface IAuthStoreActions {
  login: VoidFunction
  logout: VoidFunction
  saveUser: (user: ILoggedUser) => void
  setMe: (user: ILoggedUser) => void
  resetAuth: VoidFunction
  // selectAuthState: (state: IAuthStore) => boolean
}

const initial: IAuthStore = {
  isAuthorized: false,
  me: undefined
}

export const useAuthStore = create<IAuthStore & IAuthStoreActions>()(
  persist(
    (set, get) => ({
      ...initial,
      login: () => set({ isAuthorized: true }),
      setMe: me => set({ me }),
      saveUser: me => set({ me, isAuthorized: true }),
      resetAuth: () => set({ ...initial }),
      logout: () => {
        Auth.logout()
        set({ isAuthorized: false, me: undefined })
      }
    }),
    {
      name: "auth-store",
      partialize: state => ({
        isAuthorized: state.isAuthorized,
        me: state.me
      })
    }
  )
)

export const selectorIsAuthorized = (state: IAuthStore) => state.isAuthorized
